import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Button from 'src/component/UI/Button';
import { FormHelperText, InputLabel } from '@mui/material';
import DeviceLinkCombo from 'src/component/UI/DeviceLinkCombo';
import { createDeviceGroup, updateDeviceGroup } from 'src/module/groupDevices/action';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'src/i18n';

export default function CreateGroupModal ({ deviceIds, open, handleClose, groupId, initialGroupName, knownDevices }) {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [groupName, setGroupName] = useState(initialGroupName);
  const location = useLocation();
  const isEdit = Boolean(groupId);
  // group members mostly aren't in the device store, so fall back to the group's own records
  const knownDevicesById = new Map((knownDevices ?? []).map((d) => [d.get('device_id'), d]));

  // In edit mode the group name arrives with the fetched group, which can land after this
  // modal has mounted — adopt it, but never over top of something the user has typed.
  const nameTouched = useRef(false);
  useEffect(() => {
    if (nameTouched.current) {
      return;
    }
    setGroupName(initialGroupName);
  }, [initialGroupName]);

  const saveGroup = () => {
    if (groupName != '') {
      const redirect = location.pathname !== '/program/list/wizard';
      if (isEdit) {
        dispatch(updateDeviceGroup(groupId, groupName, deviceIds, redirect));
      } else {
        dispatch(createDeviceGroup(groupName, [deviceIds], redirect));
      }
      handleClose();
      if (!isEdit) {
        nameTouched.current = false;
        setGroupName('');
      }
    } else {
      setError(true);
    }

    return;
  };
  const devicesCol = (devices) => {
    if (!devices || !devices.length) {
      return [];
    }
    return devices.map((device, index) => (<div key={index} className='groups-list'><DeviceLinkCombo deviceId={device} device={knownDevicesById.get(device)} /></div>));
  };
  const handleGroupNameChange = (event) => {
    nameTouched.current = true;
    setGroupName(event);
    if (event === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  const renderGroupName = () => {
    return (
      <div>
        <TextField required  label={t('createGroup.groupName')} fullWidth value={groupName} error={error} onChange={(e) => { handleGroupNameChange(e.target.value);}}  />
        {error && <FormHelperText error={Boolean(error)}>{t('createGroup.required')}</FormHelperText>}
      </div>
    );
  };

  return (
    <Modal
      data-testid='create-device-group-modal'
      open={open}
      onClose={handleClose}
      aria-labelledby='create-device-group-modal'
    >
      <div className='modal confirm-modal'>
        <h2 id='confirm-modal-title'>{isEdit ? t('createGroup.editGroup') : t('createGroup.title')}</h2>
        <form onSubmit={saveGroup}>
          <div>
            {renderGroupName()}
            <div style={{ paddingTop: '5px' }}>
              <InputLabel>{t('createGroup.devices')}</InputLabel>
              <div style={{ height: '170px', overflowY: 'auto' }}>{devicesCol(deviceIds)}</div>
            </div>
          </div>

          <div className='button-bar'>
            <Button cta onClick={saveGroup} >{t('createGroup.saveGroup')}</Button>
          </div>
        </form>




      </div>

    </Modal>
  );
}

CreateGroupModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  deviceIds: PropTypes.array.isRequired,
  groupId: PropTypes.string,
  initialGroupName: PropTypes.string,
  knownDevices: ImmutablePropTypes.list,
};

CreateGroupModal.defaultProps = {
  groupId: null,
  initialGroupName: '',
  knownDevices: null,
};
